/* eslint-disable */
const BASE_MANAGE = {
  BASE_MANAGE_SYSTEM_EDIT_VARIABLE: 'base/manage/system/edit/variable',
  BASE_MANAGE_SYSTEM_GET_APPVERSION: 'base/manage/system/get/appVersion',
  BASE_MANAGE_SYSTEM_EDIT_APPVERSION_INFO: 'base/manage/system/edit/appVersion/info',
  BASE_MANAGE_SYSTEM_ADD_APPVERSION: 'base/manage/system/add/appVersion',
  BASE_MANAGE_SYSTEM_EDIT_APPVERSION_FILE: 'base/manage/system/edit/appVersion/file',
  BASE_MANAGE_SYSTEM_ENABLE_APPVERSION: 'base/manage/system/enable/appVersion',
  BASE_MANAGE_SYSTEM_DISABLE_APPVERSION: 'base/manage/system/disable/appVersion',
  BASE_MANAGE_SYSTEM_DELETE_APPVERSION: 'base/manage/system/delete/appVersion',
  BASE_SYSTEM_TIMESTAMPTOMOUNTINVERVAL: 'public/base/system/timeStampToMonthInterval',

  BASE_MANAGE_TYPE_DISABLE_REASON: 'base/manage/type/disable/reason',
  BASE_MANAGE_TYPE_ENABLE_REASON: 'base/manage/type/enable/reason',
  BASE_MANAGE_TYPE_DELETE_REASON: 'base/manage/type/delete/reason',
  BASE_MANAGE_TYPE_EDIT_REASON: 'base/manage/type/edit/reason',
  BASE_MANAGE_TYPE_DISABLE_PAYMENT: 'base/manage/type/disable/payment',
  BASE_MANAGE_TYPE_ENABLE_PAYMENT: 'base/manage/type/enable/payment',
  BASE_MANAGE_TYPE_EDIT_PAYMENT: 'base/manage/type/edit/payment',
  BASE_MANAGE_TYPE_DELETE_PAYMENT: 'base/manage/type/delete/payment',
  BASE_MANAGE_TYPE_DISABLE_CITY: 'base/manage/type/disable/city',
  BASE_MANAGE_TYPE_ENABLE_CITY: 'base/manage/type/enable/city',
  BASE_MANAGE_TYPE_DELETE_CITY: 'base/manage/type/delete/city',
  BASE_MANAGE_TYPE_EDIT_CITY: 'base/manage/type/edit/city',
  BASE_MANAGE_TYPE_DISABLE_PROVINCE: 'base/manage/type/disable/province',
  BASE_MANAGE_TYPE_ENABLE_PROVINCE: 'base/manage/type/enable/province',
  BASE_MANAGE_TYPE_DELETE_PROVINCE: 'base/manage/type/delete/province',
  BASE_MANAGE_TYPE_EDIT_PROVINCE: 'base/manage/type/edit/province',
  BASE_MANAGE_TYPE_DISABLE_CAR: 'base/manage/type/disable/car',
  BASE_MANAGE_TYPE_ENABLE_CAR: 'base/manage/type/enable/car',
  BASE_MANAGE_TYPE_DELETE_CAR: 'base/manage/type/delete/car',
  BASE_MANAGE_TYPE_EDIT_CAR_INFO: 'base/manage/type/edit/car/info',

  BASE_MANAGE_TYPE_ADD_PAYMENT: 'base/manage/type/add/payment',
  BASE_MANAGE_TYPE_ADD_CITY: 'base/manage/type/add/city',
  BASE_MANAGE_TYPE_ADD_CAR: 'base/manage/type/add/car',
  BASE_MANAGE_TYPE_ADD_REASON: 'base/manage/type/add/reason',
  BASE_MANAGE_PAYMENT_ADD_BANK: 'base/manage/payment/bank/add',
  BASE_MANAGE_PAYMENT_GET_LIST_BANK: 'base/manage/payment/bank/get/list',
  BASE_MANAGE_PAYMENT_DELETE_BANK: 'base/manage/payment/bank/delete',
  BASE_MANAGE_PAYMENT_UPDATE_BANK: 'base/manage/payment/bank/update',
  BASE_MANAGE_PAYMENT_ADD_TERMINAL: 'base/manage/payment/terminal/add',
  BASE_MANAGE_PAYMENT_GET_LIST_TERMINAL: 'base/manage/payment/terminal/get/list',
  BASE_MANAGE_PAYMENT_DELETE_TERMINAL: 'base/manage/payment/terminal/delete',
  BASE_MANAGE_PAYMENT_UPDATE_TERMINAL: 'base/manage/payment/terminal/update',
  BASE_MANAGE_PAYMENT_GET_ID_TERMINAL: 'base/manage/payment/terminal',
  BASE_MANAGE_PAYMENT_GET_HISTORY_LIST_TERMINAL: 'base/manage/payment/terminal/history/get/list'
}
export default BASE_MANAGE
